<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <b-tabs v-model="activeTab">
        <b-tab title="الثناءات">
          <b-list-group>
            <b-list-group-item
              :to="{ name: 'incentive-show', params: { id: reward.id } }"
              v-for="reward in incentives.rewards"
              :key="reward.id"
              class="flex-column align-items-start"
              :class="{ 'bg-light': !reward.read_at }"
            >
              <div class="d-flex w-100 justify-content-between">
                <div class="d-flex align-items-center">
                  <h5>
                    {{ reward.name }}
                  </h5>
                </div>

                <div>
                  <small dir="ltr" class="text-secondary">
                  {{ formatDate(reward.created_at, "YYYY-MM-DD") }}</small>
                </div>
              </div>

              <div class="text-secondary">
                {{ reward.incentiveType.name_ar }}
              </div>
            </b-list-group-item>

            <div v-if="incentives.rewards.length === 0" class="p-1 text-center">
              لا توجد أي ثناءات
            </div>
          </b-list-group>
        </b-tab>
        <b-tab title="العقوبات">
          <b-list-group>
            <b-list-group-item
              :to="{ name: 'incentive-show', params: { id: punishment.id } }"
              v-for="punishment in incentives.punishments"
              :key="punishment.id"
              class="flex-column align-items-start"
              :class="{ 'bg-light': !punishment.read_at }"
            >
              <b-row class="d-flex w-100 justify-content-between">
                <b-col cols="3">

                  <h5>{{ punishment.name }}</h5>
                </b-col>
                <b-col cols="3" class="d-flex justify-content-center">

                  <div>
                    <b-badge
                        pill
                        :variant="punishment.status=== 'confirmed' ? 'light-danger' : punishment.status=== 'under_study' ? 'light-secondary' : 'light-success'"
                      >
                        {{ punishment.status=== 'confirmed' ? 'محققة' : punishment.status=== 'under_study' ? 'تحت الدراسة' : 'مًلغاة' }}
                      </b-badge>
                  </div>
                </b-col>
                <b-col cols="3" class="d-flex justify-content-center">
                  <div v-if="punishment.transaction_request_id"> 
                    وفق المعاملة 
                    <b-badge
                        pill
                        variant="light-secondary"
                      >
                        {{ punishment.transaction_request_id }} 
                      </b-badge>
                  </div>
                </b-col>
                <b-col cols="3" class="d-flex justify-content-end">

                  <div>
                    <small dir="rtl" class="text-secondary">
                    {{ formatDate(punishment.created_at, "YYYY-MM-DD") }}</small>
                  </div>
                </b-col>
              </b-row>

              <div class="text-secondary">
                {{ punishment.incentiveType.name_ar }}
              </div>
            </b-list-group-item>

            <div
              v-if="incentives.punishments.length === 0"
              class="p-1 text-center"
            >
              لا توجد أي عقوبات
            </div>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BCard,
  BLink,
  BTabs,
  BTab,
  BButton,
  BCol,
  BContainer,
  BListGroup,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";

import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { formatDate } from "@/utils/utils";
export default {
  components: {
    BRow,
    BCard,
    BLink,
    BButton,
    BCol,
    BContainer,
    BListGroup,
    BListGroupItem,
    BBadge,
    BTabs,
    BTab,
    LoadingOverlay,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    ...mapActions("MinistryRelation/Incentives", ["getIncentives"]),
    formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
  },
  computed: {
    ...mapGetters("MinistryRelation/Incentives", ["incentives", "loading"]),
  },

  created() {
    this.getIncentives();
  },
};
</script>
